import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterReport'
})
export class FilterReportPipe implements PipeTransform {

  transform(reports: any, term: any): any {
    // check if term is undefined
    if (term === undefined || term.length == 0 || reports === null || term.length == 0) {
       return reports;
    }
    // return the updated reports array
    return reports.filter(function(r){
    return r.name.toLowerCase().includes(term.toLowerCase()) || r.description.toLowerCase().includes(term.toLowerCase());
    });
  }
}